import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(public)/services/RealizationsList.tsx");
